import {app} from './feathers';
import store from '../store/index';
import router from '../router';

async function setInStore(data, next) {
	store.commit('auth/AUTH_SUCCESS', data);
	if (next) {
		const nextUrl = next.trim();
		if (nextUrl !== '') {
			router.push(nextUrl);
		} else {
			if (router.currentRoute.path.includes('/entrar')) router.push('/');
		}
	} else {
		if (data.is_admin) {
			router.push('/admin');
		} else {
			router.push('/');
			location.reload();
		}
	}
}

function removeFromStore() {
	sessionStorage.clear();
	store.commit('auth/AUTH_LOGOUT');
}

export default {
	login: async (data, is_admin, next) => {
		try {
			if (is_admin) {
				app.authentication.options.path = '/authentication-admin';
				localStorage.setItem('admin', true);
			} else {
				app.authentication.options.path = '/authentication';
				localStorage.setItem('admin', false);
			}
			const r = await app.authenticate({
				strategy: 'local',
				email: data.email,
				password: data.password,
			});
			if (is_admin) r.adminusers['is_staff'] = true;
			else r.user['is_staff'] = false;
			await setInStore(
				{
					token: r.accessToken,
					user: is_admin ? r.adminusers : r.user,
					is_admin: is_admin,
				},
				next
			);
		} catch (err) {
			removeFromStore();
			return err;
		}
	},
	reauthenticate: async () => {
		try {
			const is_admin = JSON.parse(localStorage.getItem('admin'));
			if (is_admin) app.authentication.options.path = '/authentication-admin';
			else app.authentication.options.path = '/authentication';
			const form = await app.reAuthenticate();
			if (is_admin) form.adminusers['is_staff'] = true;
			else form.user['is_staff'] = false;
			const data = {
				token: form.accessToken,
				user: is_admin ? form.adminusers : form.user,
			};
			store.commit('auth/AUTH_SUCCESS', data);
		} catch (error) {
			removeFromStore();
		}
	},
	logout: () => {
		app.logout()
			.then(() => {
				removeFromStore();
				router.push('/entrar');
				
			})
			.catch(() => {});
	},
};
